import { render, staticRenderFns } from "./guide-teacher.vue?vue&type=template&id=bf465832&scoped=true&"
import script from "./guide-teacher.vue?vue&type=script&lang=js&"
export * from "./guide-teacher.vue?vue&type=script&lang=js&"
import style0 from "./guide-teacher.vue?vue&type=style&index=0&id=bf465832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf465832",
  null
  
)

export default component.exports